import { css } from 'styled-components';

import { mapControlWidth } from './constants';

export const LayersMessages = css`
  .lt-map-layers-message {
    position: absolute;
    z-index: 100;
    top: 0;
    left: 65px;
    left: ${mapControlWidth + 20};
    width: calc(100% - #{${mapControlWidth}} - 50px);
    min-width: 230px;
    max-width: 280px;

    &__container {
      position: relative;
      padding: 10px 15px;
      overflow: hidden;
      width: 100%;
      min-width: 230px;
      max-width: 280px;
      font-size: 15px;
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.2);
    }

    &__tooltip {
      position: absolute;
      top: 50%;
      margin-top: -14px;
      display: block;
      width: 20px;
      height: 20px;
      background: #fff;
      box-shadow: 1px 0 5px rgba(0, 0, 0, 0.3);
      transform: translateX(-50%) rotate(45deg);
    }

    &__close {
      position: absolute;
      z-index: 10;
      top: 10px;
      right: 10px;
      overflow: hidden;
      width: 25px;
      height: 25px;
      background: none;
      border: none;
      outline: none;
      cursor: pointer;

      &::before,
      &::after {
        position: absolute;
        top: 50%;
        left: 18%;
        margin-top: -1px;
        width: 66%;
        height: 1px;
        opacity: 0.66;
        content: '';
        background: #000;
      }

      &::before {
        transform: rotate(45deg);
      }

      &::after {
        transform: rotate(-45deg);
      }

      &:hover {
        &::before,
        &::after {
          background: #1ebcc5;
        }
      }
    }

    h3 {
      font-size: 17px;
      font-weight: bold;
    }

    div {
      margin-bottom: 6.4px;
      line-height: normal;
    }
  }

  .body-isMobile .lt-map-layers-message__container {
    min-width: 235px;
  }
`;
